// extracted by mini-css-extract-plugin
module.exports = {"Title":"External_Title__1KPeL","ExternalWrapper":"External_ExternalWrapper__2bohY","Link":"External_Link__2v00b","Button":"External_Button__2TMw4"};